import React from 'react';
import { Theme as AugmentedTheme } from '@mui/material/styles';

import { makeStyles } from 'tss-react/mui';
import {
  BasicAttachedFiles,
  Box,
  Button,
  CustomDropZone,
  CustomDropZoneProps,
  Grid,
  Typography,
} from 'web-library';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles()((theme) => ({
  root: {
    flexGrow: 1,
    minHeight: '450px',
  },
  container: {
    margin: theme.spacing(1),
    width: '100%',
  },
  bulkLabel: {
    color: theme.color.text.textHeader,
  },
  downloadButton: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  noteLabel: {},
  dropZone: {
    marginBottom: theme.spacing(6),
    width: '100%',
  },
  downloadTemplateButton: {
    // width:
  },
}));

export type GridBreakPoints = 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12;

export interface BulkUploadProps extends CustomDropZoneProps {
  /** to apply breakpoint for extra small devices
   * */
  xs?: GridBreakPoints;
  /** to apply breakpoint for small devices
   * */
  sm?: GridBreakPoints;
  /** to apply breakpoint for medium devices
   * */
  md?: GridBreakPoints;
  /** to apply breakpoint for large devices
   * */
  lg?: GridBreakPoints;
  /** to handle dwonload template event
   * */
  onDownloadTemplate?: () => void;
  /** to handle the Upload file upload event
   * */
  onChange?: (files: File[]) => void;
  /** to handle the Upload file delete event
   * */
  onDelete?: (file: File) => void;
  /** to define uploaded file value
   * */
  initialFiles?: File[] | [];
  /** to limit the number of files for upload
   * */
  filesLimit?: 1 | 2 | 3;
  /** to define the accept file format
   * */
  acceptedFiles?: [];
  /** to set the key for component (workaround for remove files programmatically)
   * */
  key?: number;
}

const BulkUpload: React.FC<BulkUploadProps> = (props: BulkUploadProps) => {
  const { classes: useClasses } = useStyles();
  const { t } = useTranslation();

  const {
    xs = 12,
    sm = 12,
    md = 12,
    lg = 12,
    initialFiles,
    acceptedFiles,
    filesLimit = 1,
    onDownloadTemplate = () => {
      // do nothing
    },
    onChange = (files: File[]) => files,
    onDelete = (file: File) => null,
    key,
  } = props;

  return (
    <div className={useClasses.root}>
      <Grid xs={xs} sm={sm} md={md} lg={lg}>
        <Typography className={useClasses.bulkLabel} display="inline" variant="h5">
          {t('components->>BulkUpload.Bulk Upload')}
        </Typography>

        <Box className={useClasses.downloadButton}>
          <Button
            id="button-bulkUpload-downloadTemplate"
            size="small"
            className={useClasses.downloadTemplateButton}
            variant="outlined"
            onClick={onDownloadTemplate}
          >
            {t('components->>BulkUpload.Download Template')}
          </Button>
        </Box>
      </Grid>
      <Grid xs={xs} sm={sm} md={md} lg={lg}>
        <Typography display="inline" variant="body2" className={useClasses.noteLabel}>
          {t(
            'components->>BulkUpload.(Note: For registration using bulk upload,' +
              ' we recommend you download the csv template to complete' +
              ', and upload the completed template into the dropbox below)'
          )}
        </Typography>
      </Grid>
      <Grid xs={xs} sm={sm} md={md} lg={lg}>
        <CustomDropZone
          filesLimit={filesLimit}
          acceptedFiles={acceptedFiles}
          className={useClasses.dropZone}
          key={key}
          initialFiles={initialFiles}
          onChange={onChange}
          onDelete={onDelete}
        />
        <BasicAttachedFiles initialFiles={initialFiles} onDelete={onDelete} />
      </Grid>
    </div>
  );
};

export default BulkUpload;
